import { useQuery } from "@tanstack/react-query"
import { getRfqBuyerToAdmin, type RfqFilterParams } from "@/lib/api/rfq.api"
import { useAuthStore } from "@/store/auth.store"

export function useGetBuyerRfqs(filters?: RfqFilterParams) {
  const accessToken = useAuthStore((s) => s.accessToken)

  return useQuery({
    queryKey: ["buyer-rfqs", filters],
    queryFn: ({ signal }) => getRfqBuyerToAdmin(accessToken!, filters, signal),
    enabled: !!accessToken,
    staleTime: 0,
  })
}
